import { Badge, type BadgeProps } from "@mantine/core";

export type Severity = "critical" | "high" | "medium" | "informational";

const COLOR: Record<Severity, BadgeProps["color"]> = {
  critical: "red",
  high: "orange",
  medium: "yellow",
  informational: "gray",
};

export function SeverityChip({ severity }: { severity: Severity }) {
  return (
    <Badge color={COLOR[severity]} variant="filled" radius="sm" size="sm">
      {severity}
    </Badge>
  );
}
